namespace GeniuzPOS.Inventory {
    export interface IcTranTypeForm {
        TranTypeNo: Serenity.StringEditor;
        TranTypeDesc: Serenity.StringEditor;
    }

    export class IcTranTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcTranType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcTranTypeForm.init)  {
                IcTranTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(IcTranTypeForm, [
                    'TranTypeNo', w0,
                    'TranTypeDesc', w0
                ]);
            }
        }
    }
}
